// src/auth/auth0Config.js
//
// Auth0 credentials are read from build-time environment variables.
// Never hardcode real values here — use --build-arg at docker build time,
// or set REACT_APP_AUTH0_DOMAIN and REACT_APP_AUTH0_CLIENT_ID in your .env file.
//
// If either value is missing the app will log a warning and Auth0 login
// will be disabled (the app still works for unauthenticated recipe search).

const domain   = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

if (!domain || !clientId) {
  console.warn(
    '[ohapotato] Auth0 is not configured. ' +
    'Set REACT_APP_AUTH0_DOMAIN and REACT_APP_AUTH0_CLIENT_ID ' +
    'as --build-arg values (Docker) or in your .env file (local dev).'
  );
}

export const auth0Config = {
  domain:   domain   || '',
  clientId: clientId || '',
  authorizationParams: {
    redirect_uri: window.location.origin,
  },
};
